import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {IconDefinition} from '@fortawesome/fontawesome-common-types';

import MobileLink from '../mobile-link/mobile-link';
import Tab from './Tab';
import usePlatformContext from 'src/hooks/usePlatform';

type TabButtonProps = RouteComponentProps & {
  label: string;
  path: string;
  icon?: IconDefinition;
};

const TabButton = ({label, path, icon, location: {pathname}}: TabButtonProps) => {
  const {isIonic} = usePlatformContext();
  if (!icon && isIonic) {
    throw new Error('Icon is required for mobile');
  }
  return (
    <MobileLink to={path} role="tab">
      <Tab active={path === pathname} icon={icon}>
        {label}
      </Tab>
    </MobileLink>
  );
};

export default withRouter(TabButton);
